/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { CTAs, Button } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from '../../../../../../utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from './marketing_styles';



/* ========== ~~~~~~~~~~ MARKETING PAGE - TRENDING ~~~~~~~~~~ ========== */
const MarketingPage = injectSheet(styles)((props) => {
  return (
    <div className={`marketingpage ${props.classes.marketing}`}>
      <div className={'content'}>
        <div className={'desc'}>
          <h2>Increase the Engagement of <span className={'clump'}>Your Visitors</span></h2>
          <h3>Recirculate your most popular articles</h3>
          <p>Your visitors can easily access your site’s top articles based on popularity, number of comments, or their specific interests. Access to this list of articles will keep them engaged and spend additional time on your site.</p>
          <CTAs>
            <Button name={'trending-request-access'} type={'action'} variant={'primary'} text={'Request Free Access'} icon={'unlock-alt'} action={props.onRequest} iconRight={true}/>
          </CTAs>
        </div>
        <div className={'graphic'}>
          <img src={`${url.tnu.pubPortal.images}/trendingnow-nobg.jpg`} />
        </div>
      </div>
    </div>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MarketingPage;

